import React, { useState, useEffect, useRef } from 'react';
import { StyledPriceModalDiv } from './index.styles';
import { renderedData } from '../../organisms/SearchResults/searchResultsMainComponent';
import {
  SearchFacetsConstants,
  SearchFacetsList,
  DefaultValue,
  SearchFacetsListCodes,
  SearchSortFields,
} from '../../organisms/SearchResults/index.constant';
import { PriceFilter } from '.';
import {
  getSearchFilterInitialState,
  getSearchAppliedFilter,
  SearchActions,
} from '../../organisms/SearchResults/store/store.action';
import {
  SearchStateExtendsType,
  SearchStateFilterObj,
  SearchFacetsResponse,
} from '../../organisms/SearchResults/store/store.type';
import { eventUtil } from '@marriott/mi-ui-library-shop';
import { Button, usePortalStyle } from '@marriott/mi-ui-library';
import { useConditionalSessionUpdateContext } from '../../hooks';

import { updateQueryParams, getTotalFilterCount } from '../../organisms/SearchResults/lib/helper';
import { Modal } from '@marriott/mi-ui-library';
import { useConditionalPageContextSERP } from '../../hooks';
import { useCheckBreakpoint } from '@marriott/mi-ui-library';
import { conditionalToggleUnsuccessfulSellUrlParameter } from '../../utils/src/helper';
import { MAP_VIEW_SESSION_KEY } from '../../modules/store/store.constants';
import { useConditionalSearchResultsRenderedDataSERP } from '../../hooks/lib/useConditionalRenderedData';
import { useConditionalSearchFilterContextWithSerpFlag } from '../../hooks/lib/useConditionalSearchFilterContext';
declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    custom_click_track_value?: string;
  }
}

export const PriceModalComponent: React.FC<{
  hideTaxesToggle: boolean;
  filterData?: Array<SearchFacetsResponse>;
  setFetchCurrencyConversionFactors: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ hideTaxesToggle, filterData, setFetchCurrencyConversionFactors }) => {
  const clickTrackingLoc = 'Phoenix Search Results';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { jsonContent, setFeatureSelected, isMapViewEnabled, setIsTaxesandFeesIncludedFromPopup }: any =
    useConditionalSearchResultsRenderedDataSERP(renderedData);
  const { searchQueryState, setSearchQuery } = useConditionalSearchFilterContextWithSerpFlag();
  const { interactionsSelected, setInteractionsSelected } = useConditionalSessionUpdateContext();
  const { headersData } = useConditionalPageContextSERP();

  const [popupOpenState, setPopupOpenState] = useState(false);
  const [filterSelectionData, setFilterSelectionData] = useState<SearchStateExtendsType | undefined | null>(
    getSearchFilterInitialState(searchQueryState)
  );
  const [includeTaxes, setIncludeTaxes] = useState<boolean>(searchQueryState[SearchFacetsConstants.includeTaxes]);
  useEffect(() => {
    if (includeTaxes !== searchQueryState[SearchFacetsConstants.includeTaxes]) {
      setIncludeTaxes(searchQueryState[SearchFacetsConstants.includeTaxes]);
    }
  }, [searchQueryState[SearchFacetsConstants.includeTaxes]]);
  const [currCurrency, setCurrCurrency] = useState<string>(searchQueryState.currentCurrency);
  const [currFilterData, setCurrFilterData] = useState<Array<SearchFacetsResponse> | undefined>(filterData);
  const [isFilterUpdate, setIsFilterUpdated] = useState<boolean>(false);

  const bodyRef = useRef<HTMLBodyElement | null>(null);
  const isDesktop = useCheckBreakpoint('viewportM'); // check if viewport is desktop till 768px
  const [isTaxesAndFeesToggled, setIsTaxesAndFeesToggled] = useState(false); // state to check if user has toggled the taxesAndFees switch

  const { setContainerRef, PortalStyleProvider } = usePortalStyle();

  useEffect(() => {
    bodyRef.current = document.body as HTMLBodyElement;
  }, []);

  const onFilterChange = (type: SearchFacetsList, data: SearchStateFilterObj): void => {
    let arr1: SearchStateExtendsType = { ...filterSelectionData };
    if (filterSelectionData) {
      arr1[type] = data;
    } else {
      arr1 = {
        [type]: data,
      };
    }
    if (!isFilterUpdate) {
      /*** if user interact with filter */
      setIsFilterUpdated(true);
    }
    setFilterSelectionData(arr1);
    setFetchCurrencyConversionFactors(true);
    setInteractionsSelected({ ...interactionsSelected, price: true });
  };

  const onUpdateIncludeTax = (val: boolean): void => {
    if (searchQueryState?.includeTaxesAndFees !== val) {
      setIsTaxesAndFeesToggled(true);
    } else {
      setIsTaxesAndFeesToggled(false);
    }
    setIncludeTaxes(val);
    setInteractionsSelected({ ...interactionsSelected, taxesAndFees: true });
    if (!isFilterUpdate) {
      /*** if user interact with filter */
      setIsFilterUpdated(true);
    }
  };

  const onUpdateCurrency = (curr: string): void => {
    setCurrCurrency(curr);
    setInteractionsSelected({ ...interactionsSelected, currencyConversion: true });
  };

  // Convert taxAndCurrency to state to fix React Compiler error
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [taxAndCurrency, setTaxAndCurrency] = useState<{
    includeTaxes?: boolean;
    currCurrency?: string;
  }>({});

  const applyBtnHandler = (): void => {
    setIsTaxesAndFeesToggled(false); // set this to false(reset to default) when user clicks on apply
    setTaxAndCurrency({});
    const payload = filterSelectionData === undefined ? { [SearchFacetsList.price]: {} } : filterSelectionData;
    const price = payload?.[SearchFacetsList.price]
      ? Object.values(payload?.[SearchFacetsList.price] as SearchStateFilterObj)
      : [0];

    if (
      currCurrency !== searchQueryState.currentCurrency &&
      (getTotalFilterCount(payload) !== getTotalFilterCount(searchQueryState) || isFilterUpdate)
    ) {
      // in order to update the filter change with currency change we have to publish this event
      setIsFilterUpdated(false);
      eventUtil.dispatch('observeFilterChangeToUpdateTheDataWithCurrency', true);
    }

    // conditionally toggle unsuccessfulsell url parameter
    conditionalToggleUnsuccessfulSellUrlParameter(currCurrency);

    // Update the selected filter values in the URL
    updateQueryParams(
      {
        includeTaxes,
        selectedCurrency: currCurrency,
        priceRangeIndex: [Number(price.length >= 1 ? price[0] : 0)],
      },
      ['includeTaxes', 'selectedCurrency', 'priceRangeIndex'],
      headersData?.referer
    );
    setSearchQuery({
      type: SearchActions.updateCurrency,
      payload: {
        currentCurrency: currCurrency,
      },
    });
    setSearchQuery({
      type: SearchActions.updateTaxesAndAvailability,
      payload: {
        [SearchFacetsConstants.includeTaxes]: includeTaxes,
      },
    });
    setSearchQuery({
      type: SearchActions.updateOtherSearchQueryParam,
      payload: {
        [SearchFacetsConstants.offset]: 0,
      },
    });
    setSearchQuery({ type: SearchActions.setApplyFilter, payload: payload });
    // create copy of filterSelectionData and searchQueryState to compare the values using for loop
    const priceFilterSelectionData = filterSelectionData?.PRICE;
    const priceFilterSearchQuery = searchQueryState[SearchFacetsList.price];

    //isFilterUpdated is used to determine if any value changed for filterSelectionData and payload
    let isFilterUpdated = false;
    if (JSON.stringify(priceFilterSelectionData) !== JSON.stringify(priceFilterSearchQuery)) {
      //comparing each filter data inside filterSelectionData and payload to determing if filters are changed.
      isFilterUpdated = true;
    }
    //should call UXL only if filters are updated(excluding taxes and fee toggle) OR if sort option is SOrt by price then also call UXL for every scenario
    const shouldCallUXL =
      isFilterUpdated ||
      (searchQueryState?.sort?.fields?.[0].field === SearchSortFields.price && isTaxesAndFeesToggled);

    //call api only if filters are updated, this doesnot include taxed and fee toggle change
    if (shouldCallUXL) {
      setSearchQuery({
        type: SearchActions.setQuery,
        payload: {
          [SearchFacetsConstants.facets]: {
            ...getSearchAppliedFilter(payload, searchQueryState),
          },
          [SearchFacetsConstants.options]: {
            ...searchQueryState.search[SearchFacetsConstants.options],
            [SearchFacetsConstants.includeTaxes]: true,
            [SearchFacetsConstants.unavailableProperties]:
              searchQueryState[SearchFacetsConstants.unavailableProperties],
          },
        },
      });
    }
    const updatedTaxAndCurrency = {
      includeTaxes: includeTaxes,
      currCurrency: currCurrency,
    };
    setTaxAndCurrency(updatedTaxAndCurrency);
    setIsTaxesandFeesIncludedFromPopup(true);
    eventUtil.dispatch('taxAndCurrencySessionUpdate', updatedTaxAndCurrency);
    eventUtil.dispatch('callSessionData', true);
  };

  const isActive =
    (searchQueryState[SearchFacetsList.price] && Object.keys(searchQueryState[SearchFacetsList.price] ?? {}).length) ||
    searchQueryState.currentCurrency !== DefaultValue;

  useEffect(() => {
    setCurrFilterData(filterData);
  }, [filterData]);

  useEffect(() => {
    if (!popupOpenState && !isMapViewEnabled && bodyRef.current) {
      if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem(MAP_VIEW_SESSION_KEY) !== 'true') {
        bodyRef.current.style.overflow = 'auto';
      }
    }
  }, [popupOpenState]);

  return (
    <PortalStyleProvider>
      <StyledPriceModalDiv ref={setContainerRef}>
        <Button
          callback={(): void => {
            setCurrFilterData(undefined);
            if (!isMapViewEnabled && bodyRef.current) {
              bodyRef.current.style.overflow = 'hidden';
            }
            setPopupOpenState(!popupOpenState);
            setFilterSelectionData(getSearchFilterInitialState(searchQueryState));
          }}
          className={`m-button-primary-inverse t-label-alt-m button-secondary filter-option-button custom_click_track sm-search-result-all-filter-component-button ${
            isActive ? 'active' : ''
          }`}
          custom_click_track_value={`${clickTrackingLoc}| Filter Selection: Price |internal`}
          buttonCopy={jsonContent?.priceLabel}
        ></Button>

        {/* TODO - remove old markup after unit testing on environment */}
        {/* <button
        type="button"
        onClick={(): void => {
          setPopupOpenState(!popupOpenState);
        }}
        className={
          't-label-alt-m filter-option-button custom_click_track sm-search-result-all-filter-component-button ' +
          (isActive ? 'active' : '')
        }
        {...{ custom_click_track_value: `${clickTrackingLoc}| Filter Selection: Price |internal` }}
      >
        {jsonContent?.priceLabel}
      </button> */}
        {popupOpenState && (
          <Modal
            className={`custom-scrollbar  ${popupOpenState ? '' : 'close-popup-header'}`}
            show={true}
            handleBlur={true}
            popupOpenState={popupOpenState}
            setPopupOpenState={setPopupOpenState}
            allFilterPopUp={true}
            onClose={(): void => {
              setCurrFilterData(undefined);
            }}
            role="dialog"
            labelledBy="ModalPopup"
            modalId="ModalPopup"
            flexLayout={true}
            usePortal={true}
          >
            <Modal.Header
              // labelIcon=""
              labelText={jsonContent?.priceLabel}
              // cancelLabel=""
              popupHeaderOnCLoseFunc={() => {
                setIsTaxesAndFeesToggled(false); // set this to false(reset to default) when user clicks on cross cta
                setPopupOpenState(false);
              }}
              customHeadingClass={isDesktop ? 't-subtitle-xl' : 't-subtitle-l'}
              flexLayout={true}
            >
              <div className="filter-by-title">{jsonContent?.priceLabel}</div>
            </Modal.Header>
            <Modal.Body className="custom-scrollbar" flexLayout={true}>
              <PriceFilter
                allFilterPopUp={false}
                onItemSelect={onFilterChange}
                clearFilterState={filterSelectionData}
                onIncludeTaxesChange={onUpdateIncludeTax}
                onCurrencyUpdate={onUpdateCurrency}
                hideTaxesToggle={hideTaxesToggle}
                itemList={currFilterData?.filter(key => key.type.code === SearchFacetsListCodes.price)[0]}
              />
            </Modal.Body>
            <Modal.Footer
              popupHeaderOnCLoseFunc={setPopupOpenState}
              applyBtnClickHandler={applyBtnHandler}
              clearClickHandler={(): void => {
                setIsTaxesAndFeesToggled(false); // set this to false(reset to default) when user clicks on clear
                setInteractionsSelected({ ...interactionsSelected, taxesAndFees: true });
                setCurrFilterData(undefined);
                setIncludeTaxes(false);
                setFilterSelectionData(filterSelectionData === undefined ? null : undefined);
              }}
              clearButtonLabel={jsonContent.clearLabel}
              applyLabel={jsonContent.applyLabel}
              setFeatureSelected={setFeatureSelected}
              clickTrackingLoc={clickTrackingLoc}
              className={'pop-up-footer'}
              flexLayout={true}
            />
          </Modal>
        )}
      </StyledPriceModalDiv>
    </PortalStyleProvider>
  );
};
